import { render, staticRenderFns } from "./PharmacistUpdate.vue?vue&type=template&id=decf81c2&scoped=true&"
import script from "./PharmacistUpdate.vue?vue&type=script&lang=ts&"
export * from "./PharmacistUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistUpdate.vue?vue&type=style&index=0&id=decf81c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decf81c2",
  null
  
)

export default component.exports